import { render, staticRenderFns } from "./configFeeSummary.vue?vue&type=template&id=8ae1c0a4&scoped=true"
import script from "./configFeeSummary.vue?vue&type=script&lang=js"
export * from "./configFeeSummary.vue?vue&type=script&lang=js"
import style0 from "./configFeeSummary.vue?vue&type=style&index=0&id=8ae1c0a4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_a6c7c6c484daeff6636bea47b922569f/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ae1c0a4",
  null
  
)

export default component.exports